import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import LoginWrapper from './LoginWrapper';
import Button from '../common/Button';
import Input from '../common/Input';
import { login } from './duck';
import i18n from '../core/i18n';
import * as API from '../core/api';

const modes = {
  LOGIN: 'LOGIN',
  RESET_PASS: 'RESET_PASS',
};

class LoginScreen extends React.Component {
  state = {
    redirectToReferrer: false,
    mode: modes.LOGIN,
    resetPassSuccessMessage: null,
    resetPassSuccessErr: null,
    isResetPassLoading: false,
  };

  componentDidMount() {
    const { lang, teamName } = this.props;

    if (lang) {
      i18n.changeLanguage(lang);
      document.title = i18n.t('docTitle', { name: teamName });
    }
  }

  handleSubmit = (e) => {
    const { t } = this.props;
    e.preventDefault();

    const cases = {
      [modes.LOGIN]: () => {
        const { email, password } = this.state;
        const { hostname } = window.location;
        const subdomain = hostname.split('.')[0];

        this.props
          .login({ email, password, workspace: subdomain })
          .then(() => this.setState({ redirectToReferrer: true }));
      },
      [modes.RESET_PASS]: () => {
        const { email } = this.state;

        this.setState({ isResetPassLoading: true });
        API.post('auth/pass-reset', { email })
          .then(() =>
            this.setState({
              resetPassSuccessMessage: t('auth.resetPassSuccessMessage'),
            })
          )
          .catch((err) => alert(JSON.stringify(err)))
          .finally(() => this.setState({ isResetPassLoading: false }));
      },
    };

    return cases[this.state.mode]();
  };

  renderSubmitText = () => {
    const { t } = this.props;
    const { mode } = this.state;

    const texts = {
      [modes.LOGIN]: t('general.login'),
      [modes.RESET_PASS]: t('auth.changePassSubmit'),
    };

    return texts[mode];
  };

  render() {
    const { error, isLoading, isLoggedIn, t } = this.props;
    const { mode, isResetPassLoading, resetPassSuccessMessage } = this.state;

    const { redirectToReferrer } = this.state;
    const { from } = this.props.location.state || {
      from: { pathname: '/home' },
    };
    if (redirectToReferrer || isLoggedIn) {
      return <Redirect to={from} />;
    }

    return (
      <LoginWrapper>
        <div className="c-login__form-container">
          <form
            onSubmit={this.handleSubmit}
            className="o-box o-box--huge c-box c-box--outlined u-text-center u-margin-bottom"
            style={{ width: '330px' }}
          >
            <Input
              type="email"
              placeholder={t('general.email')}
              autoComplete="username"
              onChange={(e) => this.setState({ email: e.target.value })}
            />

            {mode === modes.LOGIN && (
              <Input
                type="password"
                placeholder={t('general.password')}
                autoComplete="current-password"
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            )}

            {mode === modes.LOGIN && (
              <div>
                <small
                  className="u-cursor-pointer"
                  onClick={() => this.setState({ mode: modes.RESET_PASS })}
                >
                  {t('auth.forgotPassword')}
                </small>
              </div>
            )}

            {resetPassSuccessMessage && mode === modes.RESET_PASS ? (
              <div className="u-color-genoa">{resetPassSuccessMessage}</div>
            ) : (
              <Button
                className={mode === modes.LOGIN && 'u-margin-top-tiny'}
                type="submit"
                disabled={isLoading}
                size="small"
              >
                {isLoading || isResetPassLoading
                  ? t('general.loading')
                  : this.renderSubmitText()}
              </Button>
            )}

            {mode === modes.RESET_PASS && (
              <div className="u-margin-top-tiny">
                <small
                  className="u-cursor-pointer"
                  onClick={() => this.setState({ mode: modes.LOGIN })}
                >
                  {t('auth.backToLogin')}
                </small>
              </div>
            )}

            {error && (
              <p className="c-alert c-alert--danger u-margin-top">{error}</p>
            )}
          </form>
        </div>
      </LoginWrapper>
    );
  }
}

const mapDispatchToProps = { login };
const mapStateToProps = ({ auth, workspace }) => ({
  isLoggedIn: !!(auth.data && auth.data.token),
  error: auth.error && auth.error.message,
  isLoading: auth.isLoading,
  lang: workspace.data && workspace.data.lang,
  teamName: workspace.data && workspace.data.name,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(translate()(LoginScreen))
);



// WEBPACK FOOTER //
// ./src/auth/LoginScreen.js